<div class="fk-input">
  @if (label !== undefined) {
    <label
      class="fk-input__label fk-text-label fk-mb3"
      [for]="id">{{ label }}</label>
  }
  <div class="fk-input__container">
    <ng-content></ng-content>
  </div>
  @if (errors && control.touched && !hideErrors) {
    <div class="fk-input__errors fk-mt3">
      @for (error of (errors | keyvalue); track error.key) {
        <div class="fk-input__error fk-caption1">
          @if (errorMessages[error.key]) {
            <span [innerHTML]="errorMessages[error.key](error.value)"></span>
          } @else {
            {{ error.key }}
          }
        </div>
      }
    </div>
  }
</div>
